'use client';
import { ListItem } from '@mui/material';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { useCitationContext } from '../StructuredContentRenderer/components/Citation/context';

import { CitationListAccordion } from './CitationListAccordion';
import { CitationRefLink } from './CitationRefLink';

export const CitationList = () => {
  const { citations } = useCitationContext();

  if (!citations || citations.length === 0) return null;

  return (
    <CitationListAccordion summary={<Typography>Articles Sources</Typography>}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography>
          NerdWallet writers are subject matter authorities who use primary, trustworthy sources to
          inform their work, including peer-reviewed studies, government websites, academic research
          and interviews with industry experts. All content is fact-checked for accuracy, timeliness
          and relevance. You can learn more about NerdWallet&apos;s high standards for journalism by
          reading our{' '}
          <Link target="_blank" href="https://www.nerdwallet.com/l/nerdwallet-editorial-guidelines">
            editorial guidelines
          </Link>
          .
        </Typography>
        <ul>
          {citations.map(citation => {
            if (!citation.citationNumber) return null;

            return (
              <ListItem
                key={citation.id}
                id={`citation-${citation.id}`}
                sx={{ padding: 0, pt: 2, alignItems: 'flex-start' }}
              >
                <CitationRefLink citationNumber={citation.citationNumber} id={citation.id} />
                <Box sx={{ flex: 1 }}>
                  <Box component="span">{citation.publication}. </Box>
                  {typeof citation.url === 'string' && (
                    <Link target="_blank" href={citation.url}>
                      {citation.title}
                    </Link>
                  )}
                  .{citation.accessDateFormatted}
                </Box>
              </ListItem>
            );
          })}
        </ul>
      </Box>
    </CitationListAccordion>
  );
};
